/**
 * AMC DC FAQ — exclusive accordion, height reveal; Q typography never mutates.
 */
(function () {
  function panel(details) {
    return details.querySelector('.amc-dc-faq__panel');
  }

  function setOpen(details, open) {
    var p = panel(details);
    if (!p) {
      details.open = open;
      return;
    }

    if (open) {
      details.open = true;
      p.style.height = '0px';
      void p.offsetHeight;
      p.style.height = p.scrollHeight + 'px';
      var done = function (e) {
        if (e && e.propertyName && e.propertyName !== 'height') return;
        if (details.open) p.style.height = 'auto';
        p.removeEventListener('transitionend', done);
      };
      p.addEventListener('transitionend', done);
    } else {
      p.style.height = p.scrollHeight + 'px';
      void p.offsetHeight;
      p.style.height = '0px';
      var closeDone = function (e) {
        if (e && e.propertyName && e.propertyName !== 'height') return;
        details.open = false;
        p.removeEventListener('transitionend', closeDone);
      };
      p.addEventListener('transitionend', closeDone);
    }
  }

  function init(root) {
    if (!root || root.dataset.amcDcFaqReady === '1') return;
    root.dataset.amcDcFaqReady = '1';

    root.querySelectorAll('.amc-dc-faq__item').forEach(function (details) {
      var p = panel(details);
      if (p) {
        p.style.height = details.open ? 'auto' : '0px';
      }
      var summary = details.querySelector('.amc-dc-faq__summary');
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        var willOpen = !details.open;
        root.querySelectorAll('.amc-dc-faq__item[open]').forEach(function (other) {
          if (other !== details) setOpen(other, false);
        });
        setOpen(details, willOpen);
      });
    });
  }

  function boot() {
    document.querySelectorAll('.amc-dc-faq').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
